





















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import Barcode from "../../components/bar-code.vue";

@Component({
    components:{ 'bar-code':Barcode }
})
export default class GenBarcode extends AbpBase{
    code : string = '';
    qty: number=1;
    height: number=60;
    fontSize: string="20";
}
